import PropTypes from "prop-types";
import IconButton from "@shared/v2/IconButton";
import { ExpandSolidV6, UploadSolidV6 } from "@shared/v2/Icomoon";
import BaseEvent from "./BaseEvent";

const RecruiterUploadEvent = ({ event, event: { timeline_fields: timelineFields } }) => (
  <BaseEvent
    icon={<UploadSolidV6 />}
    title={
      <div className="tw-flex tw-items-center tw-gap-[8px]">
        <div>
          <span className="tw-font-semibold">Recruiter</span> Upload: {timelineFields.file_name}
        </div>
        <IconButton
          size="small"
          schema="tertiary"
          onClick={() => window.open(timelineFields.file_uri, "_blank")}
        >
          <ExpandSolidV6 />
        </IconButton>
      </div>
    }
    interactedAt={event.interacted_at_absolute}
  >
    <iframe
      width="100%"
      height="300"
      className="tw-border-none"
      src={`${timelineFields.file_uri}#navpanes=0`}
      title={timelineFields.file_name}
    />
  </BaseEvent>
);

RecruiterUploadEvent.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default RecruiterUploadEvent;
